import { Box } from '@material-ui/core';
import { patchChangePassword, User } from '@nemuru-eng/js-api-client';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import {
  ChangePasswordFormSchema,
  ChangePasswordFormType,
  PASSWORD_MIN_LENGTH,
} from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUserById/schemas/ChangeUserByIdSchema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useRequest } from '@/hooks/requests/useRequest';
interface ChangePasswordFormProps {
  selectedUser: User;
  opened;
  setOpened;
  handleClose;
}

export const ChangePassword = ({ selectedUser, opened, setOpened, handleClose }: ChangePasswordFormProps) => {
  const { request, loading } = useRequest();

  const onSubmitForm = async (useFormValues: ChangePasswordFormType) => {
    await request(patchChangePassword, {
      username: selectedUser.username,
      oldPassword: useFormValues.oldPassword,
      newPassword: useFormValues.newPassword,
    });
    handleClose();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'CHANGE_PASSWORD'}
      onSubmitForm={onSubmitForm}
      saveButtonTextId={'CHANGE_PASSWORD'}
      isLoading={loading}
      formSchema={ChangePasswordFormSchema}
    >
      <>
        <Font variant={'body2'} color={'textSecondary'}>
          <Text tId={'CHANGING_PASSWORD_FOR_USER'} dynamicDataTexts={[selectedUser.username]} />
        </Font>
        <Box pt={2}>
          <FormGridContainer fieldVariant={FieldVariant.form} fullWidth>
            <TextFormField label={'OLD_PASSWORD'} name={'oldPassword'} />
            <TextFormField
              label={'NEW_PASSWORD_MIN_VALUE'}
              labelDynamicDataTexts={[PASSWORD_MIN_LENGTH]}
              name={'newPassword'}
            />
          </FormGridContainer>
        </Box>
      </>
    </EditDialogWrapper>
  );
};
